/**
 * InactivityWarningModal — aviso de inatividade com contagem regressiva.
 *
 * Apresentacional/puro: recebe os segundos restantes e o callback de
 * cancelamento. Quem dirige o estado é o hook useInactivityLogout.
 * Esc/clique-fora NÃO fecham (evita cancelar sem querer) — só o botão.
 */
import { useEffect, useRef } from 'react'

export interface InactivityWarningModalProps {
  secondsLeft: number
  onStay: () => void
}

export function InactivityWarningModal({ secondsLeft, onStay }: InactivityWarningModalProps) {
  const btnRef = useRef<HTMLButtonElement>(null)

  // Foca o botão ao abrir (acessibilidade / Enter cancela direto).
  useEffect(() => {
    btnRef.current?.focus()
  }, [])

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="inactivity-title"
      aria-describedby="inactivity-desc"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2147483000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0, 0, 0, 0.55)',
      }}
    >
      <div
        style={{
          background: 'var(--ai-surface, #fff)',
          color: 'var(--ai-text, #0f172a)',
          width: 'min(92vw, 420px)',
          borderRadius: 12,
          padding: '28px 28px 24px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.35)',
          border: '1px solid var(--ai-border-light, #e2e8f0)',
          textAlign: 'center',
        }}
      >
        <h2 id="inactivity-title" style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 700 }}>
          Você ainda está aí?
        </h2>
        <p id="inactivity-desc" style={{ margin: '0 0 6px', fontSize: 14, opacity: 0.85 }}>
          Sua sessão será encerrada por inatividade.
        </p>
        <p style={{ margin: '0 0 20px', fontSize: 28, fontWeight: 700, color: '#025468' }}>
          {secondsLeft}s
        </p>
        <button
          ref={btnRef}
          type="button"
          onClick={onStay}
          style={{
            width: '100%',
            padding: '12px 16px',
            fontSize: 15,
            fontWeight: 600,
            color: '#fff',
            background: '#025468',
            border: 'none',
            borderRadius: 8,
            cursor: 'pointer',
          }}
        >
          Continuar conectado
        </button>
      </div>
    </div>
  )
}
